import * as d3ease from 'd3-ease';

// Chord layout
export const NODE_THICKNESS = 15;

// Initial animation durations and delays
export const RIBBON_INITIAL_ANIM_DURATION = 1500;
export const RIBBON_INITIAL_ANIM_DELAY_MIN = 1200;
export const RIBBON_INITIAL_ANIM_DELAY_RANGE = 500;

export const NODELABEL_INITIAL_ANIM_DURATION = 800;
export const NODELABEL_INITIAL_ANIM_DELAY_RANGE = 1000;

export const TRIPBAR_INITIAL_ANIM_DURATION = 800;
export const TRIPBAR_INITIAL_ANIM_DELAY_MIN = 1500;
export const TRIPBAR_INITIAL_ANIM_DELAY_RANGE = 1000;

export const TRIPBARTEXT_INITIAL_ANIM_DURATION = 1000;
export const TRIPBARTEXT_INITIAL_ANIM_DELAY = 1500;

// Update animation durations and delays
export const SELECTION_ANIM_DURATION = 500;
export const REORDER_ANIM_DURATION = 1000;

// Update animation ease
export const DEFAULT_EASE = d3ease.easeQuad;
